export const CLIENT_STATUS_OPTIONS = [
	{ value: 'all', label: 'Todas' },
	{ value: 'open', label: 'Abertas' },
	{ value: 'closed', label: 'Respondidas' },
] as const;
